import ApplicationOperationForm from "@/components/field/operations/ApplicationOperationForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/operations/application/$applicationOperationId",
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { applicationOperationId, fieldId } = useParams({
        from: "/dashboard/fields/$fieldId/operations/application/$applicationOperationId",
    });
    const { t } = useTranslation("operations");
    return (
        <div className="p-2">
            <Button
                size="sm"
                as={Link}
                to="/dashboard/fields/$fieldId/operations"
                className="mb-2"
                params={
                    {
                        fieldId,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } as any
                }
            >
                <FontAwesomeIcon icon={faChevronLeft} /> {t("backToOperations")}
            </Button>
            <ApplicationOperationForm
                existingApplicationId={Number(applicationOperationId)}
            />
        </div>
    );
}
